import { render, staticRenderFns } from "./Mycollection.vue?vue&type=template&id=18d8889f&scoped=true"
import script from "./Mycollection.vue?vue&type=script&lang=js"
export * from "./Mycollection.vue?vue&type=script&lang=js"
import style0 from "./Mycollection.vue?vue&type=style&index=0&id=18d8889f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8889f",
  null
  
)

export default component.exports